var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"max-width":"600px"}},[_c('v-card-text',[(!_vm.mail)?_c('div'):_vm._e(),(_vm.mail)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.mail.MailContent)}}):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }